"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRowColGap = exports.isRollOver = exports.getPosterRatio = exports.transformProduct = exports.getTomatoWidth = exports.fetchProductPosterRadio = exports.Platform = exports.MINI_ROW_GAP = exports.MINI_UI_GAP = void 0;
var admin_1 = require("services/page/admin");
var common_1 = require("services/page/common");
var price_1 = require("utils/price");
var prm_1 = require("./prm");
exports.MINI_UI_GAP = 10;
exports.MINI_ROW_GAP = 8;
var Platform;
(function (Platform) {
    Platform["WEB"] = "web";
    Platform["MWEB"] = "mweb";
})(Platform = exports.Platform || (exports.Platform = {}));
exports.fetchProductPosterRadio = function (shape) {
    if (shape === admin_1.Shape.RectangleB) {
        return +(307 / 230).toFixed(3);
    }
    return 1;
};
exports.getTomatoWidth = function (col, customUI) {
    var w;
    switch (col) {
        case 5:
            w = 230;
            break;
        case 6:
            w = 190;
            break;
        default:
            w = 190;
            break;
    }
    return {
        imgWidth: w,
        imgHeight: w * exports.fetchProductPosterRadio(customUI === null || customUI === void 0 ? void 0 : customUI.shape)
    };
};
function transformProduct(pElement, ui, prm, spm, isMobile) {
    var floor = prm.floor, position = prm.position;
    var nextLink = prm_1.genTSpmLinkByUrl(pElement.url, floor, "", position + 1, spm);
    var imgFromShape = pElement.extra.img;
    var img = [admin_1.Shape.Square, admin_1.Shape.RectangleA].includes(ui.shape)
        ? imgFromShape.square
        : imgFromShape.rectangleA;
    var extra = transformProductExtra(pElement);
    img = img || pElement.img;
    return __assign(__assign({}, pElement), { url: nextLink, img: img, price: isMobile
            ? price_1.connectLtPriceForM(pElement.price, false)
            : price_1.connectLtPrice(pElement.price) || "", originPrice: isMobile
            ? price_1.connectLtPriceForM(pElement.originPrice, true)
            : price_1.connectLtPrice(pElement.originPrice, true) || "", extra: extra });
}
exports.transformProduct = transformProduct;
function transformProductExtra(product) {
    var _a = product.extra || {}, extraProductInfo = _a.extraProductInfo, leftView = _a.leftView, rightView = _a.rightView, flash = _a.flash;
    var imgOnTopLeft = extraProductInfo.imgOnTopLeft, imgOnTopRight = extraProductInfo.imgOnTopRight, titleTag = extraProductInfo.titleTag, extraTag = extraProductInfo.extraTag;
    return {
        rtImg: (imgOnTopRight === null || imgOnTopRight === void 0 ? void 0 : imgOnTopRight.imgs[0]) || "",
        ltImg: (imgOnTopLeft === null || imgOnTopLeft === void 0 ? void 0 : imgOnTopLeft.imgs[0]) || "",
        star: (leftView === null || leftView === void 0 ? void 0 : leftView.rateScore) || 0,
        sold: (rightView === null || rightView === void 0 ? void 0 : rightView.text) || "",
        titleImg: (titleTag === null || titleTag === void 0 ? void 0 : titleTag.imgs[0]) || "",
        twentyTour: (extraTag === null || extraTag === void 0 ? void 0 : extraTag.text) || "",
        countdownToEnd: (flash === null || flash === void 0 ? void 0 : flash.countdownToEnd) || "0"
    };
}
exports.getPosterRatio = function (customUI) {
    return [admin_1.Shape.RectangleA, admin_1.Shape.Square].includes(customUI.shape) ? 1 : 0.75;
};
exports.isRollOver = function (layout) {
    return (layout === null || layout === void 0 ? void 0 : layout.interaction) === common_1.ModuleInteraction.RollOver;
};
exports.getRowColGap = function () {
    return {
        columnGap: exports.MINI_UI_GAP,
        rowGap: exports.MINI_ROW_GAP
    };
};
